import { Trans } from '@lingui/macro';
import { ListItem, Typography, IconButton, Avatar, AvatarLetter, Card, CardHeader, List, CardContent, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
import { getMarketByCode } from 'app/domains/markets/config';
import { SSORestricted } from 'shared/domains/users/components/SSORestricted';
import useAccount from 'shared/domains/users/hooks/useAccount';
import { useAccounts } from 'shared/domains/users/hooks/useAccounts';
import { activeAccount } from 'shared/domains/users/utils/activeAccount';
import { InfoContainer } from './styled';
export function CompanyItems() {
    var _a;
    const account = useAccount();
    const accounts = useAccounts();
    const activeCompany = (_a = account.data) === null || _a === void 0 ? void 0 : _a.companyId;
    const filteredAccounts = accounts;
    const handleSelectAccount = (selection) => {
        const { id, company } = selection;
        const { marketCode } = company;
        activeAccount.set(id);
        window.location.href = `${window.location.origin}/${marketCode}`;
    };
    return (<Card size="small">
      <CardHeader title={<Trans>My Companies</Trans>} action={<SSORestricted>
            <IconButton as={Link} to="/add-company" appearance="ghost">
              <Falcon icon="plus"/>
            </IconButton>
          </SSORestricted>}/>

      <CardContent>
        <List $density="large">
          {filteredAccounts.map(({ id, company }) => (<ListItem key={id} $selected={activeCompany === company.id} onClick={() => handleSelectAccount({ id, company })}>
              <Avatar>
                <AvatarLetter>{company.name[0]}</AvatarLetter>
              </Avatar>
              <InfoContainer>
                <Typography $appearance="300" $fontSize="medium">
                  {company.name}
                </Typography>
                <Typography $lineHeight="neutralized" $appearance="200" $fontSize="small">
                  {getMarketByCode(company.marketCode).getName()}
                </Typography>
              </InfoContainer>
            </ListItem>))}
        </List>
      </CardContent>
    </Card>);
}
